import { put } from 'redux-saga/effects';
import { push } from 'react-router-redux';
//import { delay } from 'redux-saga';

import { popup_icon_type } from 'components/shared/popup/Popup';
import * as endpoint from 'misc/endpoint';
import * as types from 'misc/types';
import { getText, getBankIdPopupData } from 'misc/helpers';

export const agreement_check = true;

export function* authenticate(action) {
    // Show Bank ID popup
    yield put(getBankIdPopupData(types.SAGA_LOGIN, getText('Missing', 'Användare avbröt inloggning')));

    try {
        let response = yield endpoint.post('sessions', {
            governmentId: action.personnr
        });

        if (response.status === 202) {
            let bankidResponse = yield endpoint.location(response.data.signatureUrl);
            yield loginSuccess(bankidResponse);
        } else if (response.status === 200) {
            yield loginSuccess(response);
        }
    } catch (error) {
        yield put({ type: types.SAGA_LOGIN.FAILURE, error });

        yield put({
            type: types.POPUP_SHOW,
            payload: {
                show: true,
                icon: popup_icon_type.error,
                header: '',
                text: error.message
            }
        });
    }
}

export function* refreshSession(action) {
    let response = yield endpoint.get('sessions/' + action.customerId);
    yield put({ type: types.SAGA_LOGIN.SUCCESS, payload: response.data });
    yield put({ type: types.SAGA_SESSION_GET.SUCCESS, payload: response.data });
    yield accessDigimail(response.data.customerId, true);
}

function* loginSuccess(response) {
    yield put({ type: types.POPUP_HIDE });

    if (response.status === 204) {
        // Account does not exist
        yield put({ type: types.SAGA_LOGIN.FAILURE, error: 'Konto finns inte' });
    } else {
        // Account exists
        yield put({ type: types.SAGA_LOGIN.SUCCESS, payload: response.data });

        // Check if new non-accepted agreements exists
        if (agreement_check && response.data.missingFields && response.data.missingFields.indexOf('TAC') >= 0) {
            yield put({ type: types.SAGA_AGREEMENT_GET.REQUEST, customerId: response.data.customerId, ref: 'login' });
        } else {
            yield put({ type: types.SAGA_SESSION_GET.REQUEST, customerId: response.data.customerId });
        }
    }
}

export function* accessDigimail(customerId, redirect) {
    // Fetch tags
    yield put({ type: types.SAGA_TAGS_GET.REQUEST, customerId: customerId });

    // Fetch customer info in order to see if their email is pending
    yield put({ type: types.SAGA_CUSTOMER_GET.REQUEST, customerId: customerId, redirect: redirect });
}

export function* logout(action) {
    try {
        yield endpoint.remove('sessions/' + action.sessionId);
        yield put({ type: types.SAGA_LOGOUT.SUCCESS });

        if (action.redirect) {
            yield put(push(action.redirect));
        }
    } catch (error) {
        yield put({ type: types.SAGA_LOGOUT.FAILURE, error: error });
    }
}



// WEBPACK FOOTER //
// ./src/sagas/sessions.js